import React from "react";
import styled from "styled-components";
import {
  FaFacebookF,
  FaInstagram,
  FaYoutube,
  FaTwitter,
  FaLinkedinIn,
} from "react-icons/fa";
import InstanceContext from "./context/InstanceContext";

const SocialIconLink = styled.a`
  color: #333;
  font-size: 24px;
  margin: 0 10px;

  &:hover {
    color: #000;
  }
`;

const SocialIconsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: start;
`;

const RoundedIcon = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #eee;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 5px;

  &:hover {
    background-color: #aaa;
  }
`;

const SocialButtons = () => {
  const { settings, languageOverrides } = InstanceContext.useInstance();

  const lo = (key, fallback) => languageOverrides?.[key] ?? fallback;

  // Map icon names to icon components
  const iconMap = {
    facebook: FaFacebookF,
    instagram: FaInstagram,
    youtube: FaYoutube,
    twitter: FaTwitter,
    linkedin: FaLinkedinIn,
  };

  // Get social media links from instance settings or use defaults
  const socialLinks = settings?.socialLinks || [];

  return (
    <SocialIconsContainer>
      {socialLinks.map((social, index) => {
        const IconComponent = iconMap[social.icon];
        if (!IconComponent) return null;

        return (
          <RoundedIcon key={index}>
            <SocialIconLink href={social.url} target="_blank" rel="noreferrer">
              <IconComponent />
            </SocialIconLink>
          </RoundedIcon>
        );
      })}
    </SocialIconsContainer>
  );
};

export default SocialButtons;
